const svgHead = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n " +
  "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 20010904//EN\" \"http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd\">\n"

const MIME = { "jpg": "image/jpeg", "png": "image/png" };

async function cloneSvg({ content, width, height }){
    width  = width || '1000px';
    height = height || '1000px';
    
    const wrap = document.createElement('div');
    wrap.innerHTML = content;
    
    const $svg = wrap.firstChild
    
    const $clone = $svg.cloneNode(true);
    $clone.setAttribute('width', width);
    $clone.setAttribute('height', height);
    let cssText = "";
    
    const response = await fetch('https://cdn.xem.link/public/static/fonts.css');
    const fontCSS = await response.text();
    cssText += "\n" + fontCSS;
    
    // Tạo một <style> element để nhúng style vào SVG
    const styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.innerHTML = `<![CDATA[\n${cssText}\n]]>`;
    
    // Tạo <defs> và chèn <style> vào trong đó
    const defs = document.createElement("defs");
    defs.appendChild(styleElement);
    $clone.insertBefore(defs, $clone.firstChild);
    
    return new XMLSerializer().serializeToString($clone)
}

export async function saveSvg({ filename, value, content, width, height }) {
    let svgData = await cloneSvg({ content, width, height });
    svgData = svgData.replace('&lt;![CDATA[', '<![CDATA[');
    svgData = svgData.replace(']]&gt;', ']]>');
    let htmlContent = [svgHead + svgData]
    
    let bl = new Blob(htmlContent, { type: "image/svg+xml"})
    let a = document.createElement("a")
    filename = filename || `QRcode_${value}`
    filename = `${filename}.svg`.replace('/','')
    
    a.href = URL.createObjectURL(bl)
    a.download = filename
    a.hidden = true
    a.click()
}


export async function saveImg({ filename, value, content, width, height, type }) {
    if (!MIME[type]) throw "Error image type";
    
    let svgData = await cloneSvg({ content, width, height })
    try{
        svgData = unescape(encodeURIComponent(svgData)); // ✅ safe cho Unicode
        svgData = svgData.replace('&lt;![CDATA[', '<![CDATA[');
        svgData = svgData.replace(']]&gt;', ']]>');
    }
    catch (e){
      console.warn(e);
    }
    
    // Finish creating downloadable data
    filename = filename || `QRcode_${value}`
    filename = `${filename}.${type}`.replace('/','')
    
    let canvas = document.createElement('canvas');
    
    // View will be scaled to the requested size.
    // var size = data.requestedSize;
    canvas.setAttribute('width', width);
    canvas.setAttribute('height', height);
    
    let ctx = canvas.getContext('2d');
    let img = document.createElement('img');
    let data = btoa(svgData); // ✅ safe cho Unicode
    img.setAttribute('src', 'data:image/svg+xml;base64,' + data);
    
    return new Promise(resolve => {
        img.onload = () => {
            ctx.fillStyle = 'white';
            if (type === 'jpg') ctx.fillRect(0, 0, width, height);
            ctx.drawImage(img, 0, 0, width, height);
            // `download` attr is not well supported
            // Will result in a download popup for chrome and the
            // image opening in a new tab for others.
            
            let a = document.createElement('a');
            let data = canvas.toDataURL(MIME[type], 1);
            a.setAttribute('href', data)
            a.setAttribute('target', 'download')
            a.setAttribute('download', filename);
            a.click();
            
            resolve(data)
        };
    })
}



export function shareImg({ filename, value, content, width, height, type }) {
    if (!MIME[type]) throw "Error image type";
    
    const svgData = cloneSvg({ content, width, height })
    
    // Finish creating downloadable data
    filename = filename || `QRcode_${value}`
    filename = `${filename}.${type}`.replace('/','')
    
    let canvas = document.createElement('canvas');
    
    // View will be scaled to the requested size.
    // var size = data.requestedSize;
    canvas.setAttribute('width', width);
    canvas.setAttribute('height', height);
    
    let ctx = canvas.getContext('2d');
    let img = document.createElement('img');
    let data = btoa(unescape(encodeURIComponent(svgData))); // ✅ safe cho Unicode
    img.setAttribute('src', 'data:image/svg+xml;base64,' + data);
    
    return new Promise((resolve, reject) => {
        img.onload = async () => {
            ctx.fillStyle = 'white';
            if (type === 'jpg') ctx.fillRect(0, 0, width, height);
            ctx.drawImage(img, 0, 0, width, height);
            // `download` attr is not well supported
            // Will result in a download popup for chrome and the
            // image opening in a new tab for others.
            try{
                let data = canvas.toDataURL(MIME[type], 0.8);
                const blob = await (await fetch(data)).blob();
                const file = new File([blob], filename, { type: blob.type });
                
                await navigator.share({
                    title: filename,
                    files: [file],
                })
                resolve(`qr:share.done`.t())
            }catch (e) {
                // reject(e)
            }
            
        };
    })
}


const encodeSvgToUrl = (svg) => {
    return 'data:image/svg+xml;base64,' + btoa(svg);
}

// svg ~> image ~> canvas
const svgToCanvas = async (svg, img, strip) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (ctx === null) {
        throw new Error('context of canvas should not be null');
    }
    
    // encoded svg to url
    const url = encodeSvgToUrl(svg);
    // write data url to image
    img.setAttribute('src', url);
    
    // wait for the image to load (or fail)
    await new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
    });
    
    const box = strip ? svg.getBBox() : svg.getBoundingClientRect();
    
    canvas.width = box.width;
    canvas.height = box.height;
    
    // draw sub-image into canvas
    ctx.drawImage(img, box.x || 0, box.y || 0, box.width, box.height, 0, 0,
      box.width, box.height);
    
    return canvas;
};
